import { Link } from 'react-router-dom';

const guideImage = 'https://readdy.ai/api/search-image?query=Artistic%20editorial%20fashion%20flat%20lay%20with%20neutral%20toned%20quality%20clothing%20items%20and%20accessories%20arranged%20on%20warm%20sand%20colored%20linen%20texture%2C%20soft%20natural%20lighting%20from%20large%20window%2C%20magazine%20spread%20aesthetic%2C%20warm%20minimal%20style%2C%20organic%20flowing%20composition%2C%20subtle%20shadows%2C%20high%20detail%20commercial%20photography&width=800&height=600&seq=about-fashion-2026&orientation=landscape';

const detailImage = 'https://readdy.ai/api/search-image?query=Close%20up%20macro%20shot%20of%20premium%20woven%20fabric%20texture%20in%20warm%20oatmeal%20tone%2C%20soft%20natural%20lighting%2C%20editorial%20minimal%20photography%2C%20warm%20neutral%20aesthetic%2C%20visible%20textile%20weave%20detail%2C%20organic%20artistic%20shot%2C%20gentle%20depth%20of%20field%2C%20high%20detail&width=600&height=800&seq=about-detail-2026&orientation=portrait';

export default function AboutSection() {
  return (
    <section id="guida" className="relative bg-background-100 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Label */}
        <span className="inline-block text-xs uppercase tracking-widest text-foreground-400 mb-6 font-label">
          SEO Guide / Itaobuy
        </span>

        {/* Main content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text */}
          <div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-6">
              Cos'è <span className="text-primary-500">Itaobuy</span> Spreadsheet?
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-8 max-w-xl">
              Itaobuy Spreadsheet è uno strumento organizzato che permette agli utenti di trovare rapidamente prodotti, categorie e informazioni utili senza perdere tempo nella ricerca manuale. Il database raccoglie migliaia di prodotti suddivisi per categorie, offrendo un&apos;esperienza centralizzata dove ogni articolo è catalogato con informazioni dettagliate e link diretti.
            </p>

            {/* Comparison table */}
            <div className="overflow-hidden rounded-xl border border-background-200 mb-8">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-200/70">
                    <th className="text-left px-5 py-3 font-semibold text-foreground-800">Caratteristica</th>
                    <th className="text-left px-5 py-3 font-semibold text-primary-600">Itaobuy Spreadsheet</th>
                    <th className="text-left px-5 py-3 font-semibold text-foreground-500">Ricerca Manuale</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ['Velocità ricerca', 'Alta', 'Bassa'],
                    ['Organizzazione prodotti', 'Ottima', 'Limitata'],
                    ['Categorie', 'Complete', 'Sparse'],
                    ['Risparmio tempo', 'Elevato', 'Ridotto'],
                    ['Aggiornamenti', 'Frequenti', 'Variabili'],
                  ].map((row, i) => (
                    <tr key={i} className="border-t border-background-200/50">
                      <td className="px-5 py-3 text-foreground-700">{row[0]}</td>
                      <td className="px-5 py-3 text-primary-600 font-medium">{row[1]}</td>
                      <td className="px-5 py-3 text-foreground-400">{row[2]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Link
              to="/articolo/itaobuy-spreadsheet-guida-completa"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Leggi la guida completa
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Images */}
          <div className="flex gap-4">
            <div className="w-[40%]">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src={detailImage}
                  alt="Dettaglio tessuto moda Itaobuy Spreadsheet"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
            <div className="w-[60%] pt-12">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src={guideImage}
                  alt="Guida completa Itaobuy Spreadsheet"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}